export default {
  // Buttons
  imageChangeDetection: 'Image Change Detection',
  query: 'Search',
  reset: 'Reset',
  viewFiles: 'View Files',
  annotate: 'Annotate',
  download: 'Download',
  downloadFile: 'Download File',
  table: 'Table',
  card: 'Card',

  // Labels
  fileName: 'File Name',
  createDate: 'Create Date',
  folder: 'Folder',
  jobName: 'Job Name',
  jobId: 'Job ID',
  createTime: 'Create Time',
  preview: 'Preview',

  // Placeholders
  fileNamePlaceholder: 'File name',
  startTime: 'Start Time',
  endTime: 'End Time',

  // Table columns
  columnName: 'File Name',
  columnJobName: 'Job Name',
  columnJobId: 'Job ID',
  columnCreateTime: 'Create Time',
  columnImageVideo: 'Image/Video',
  columnAction: 'Action',

  // Routes
  allFiles: 'All Files',

  // Robot media types
  typeZm: 'Duty Free',
  typeSmt: 'smt',
  typeRetail: 'Retail',

  // Empty states
  noMediaData: 'No media data',
  loading: 'Loading...',

  // Messages
  modelMaking: 'Model is being created, please check back later',
  downloading: 'Downloading',
  annotationNotSupported: 'This file does not support entering annotation',
  annotationImageNotFound: 'No image URL found for annotation',
  annotationMissingJobInfo: 'Missing job info, cannot enter annotation',

  // Drawing status
  drawingStatus: {
    10: 'Pending',
    20: 'Processing',
    30: 'Failed',
    60: 'Completed',
    50: 'Cancelled',
  },

  // Image preview component
  imageLoadFailed: 'Image load failed',
  videoLoadFailed: 'Video load failed',
  loadFailed: 'Load failed',
  detailInfo: 'Detailed Information',
  fileNameLabel: 'File Name:',
  taskNameLabel: 'Task Name:',
  routeNameLabel: 'Route Name:',
  payloadLabel: 'Payload:',
  captureTimeLabel: 'Capture Time:',
  downloadLabel: 'Download:',
  alarmInfo: 'Alarm Information',
  accountNameLabel: 'Account Name:',
  alarmModelLabel: 'Alarm Model:',
  alarmTimeLabel: 'Alarm Time:',
  fileLocationLabel: 'File Location:',
  noLocationInfo: 'No location information',
  pointFlightDetail: 'Point Flight Details',
  nameLabel: 'Name:',
  fileSizeLabel: 'File Size',
  markAsFalseAlarm: 'Mark this image as false alarm?',
  markSuccess: 'Marked successfully',

  // Toolbar button tooltips
  zoomIn: 'Zoom In',
  zoomOut: 'Zoom Out',
  restore: 'Restore',
  markFalseAlarm: 'Mark False Alarm',
}
